import $http from "../axios";

const state = {
  buyNowPayLaterTransactions: [],
  billets: []
};

const getters = {
  buyNowPayLaterTransactions: state => {
    return state.buyNowPayLaterTransactions;
  },

  buyNowPayLaterTransactionsReverse: state => {
    return JSON.parse(
      JSON.stringify(state.buyNowPayLaterTransactions.reverse())
    );
  },

  billets: state => {
    return state.billets;
  },

  billetsReverse: state => {
    return JSON.parse(JSON.stringify(state.billets.reverse()));
  }
};

const actions = {
  getBuyNowPayLater({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get(`buy-now-pay-later`)
        .then(res => {
          if (res.data.result === "ok") {
            commit(
              "SET_BUY_NOW_PAY_LATER_TRANSACTIONS",
              res.data.payload.transactions
            );
            commit("SET_BUY_NOW_PAY_LATER_BILLETS", res.data.payload.billets);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  generateBillet({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`generate-billet`, data)
        .then(res => {
          if (res.data.result === "ok") {
            commit("ADD_BILLET", res.data.payload.billet);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_BUY_NOW_PAY_LATER_TRANSACTIONS(state, transactions) {
    state.buyNowPayLaterTransactions = transactions;
  },

  SET_BUY_NOW_PAY_LATER_BILLETS(state, billets) {
    state.billets = billets;
  },

  ADD_BILLET(state, billet) {
    state.billets.push(billet);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
